
/**
 * Period 和 WeightConfig 相关 API
 */

import api from './client';
import type { Period, WeightConfig, WeightPreset } from '../../types';

export const periodAPI = {
    list: (params?: { sku?: string | number }) => api.get<Period[]>('/periods/', { params }),
    get: (id: number) => api.get<Period>(`/periods/${id}/`),
    create: (formData: FormData) => api.post<Period>('/periods/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
    delete: (id: number) => api.delete(`/periods/${id}/`),
    reprocess: (id: number) => api.post(`/periods/${id}/reprocess/`),
    batchUpload: (formData: FormData) => api.post('/periods/batch_upload/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 600000,
    }),
    checkBatchTask: (taskId: string) => api.get('/periods/check_batch_task/', {
        params: { task_id: taskId }
    }),
};

export const weightConfigAPI = {
    list: () => api.get<WeightConfig[]>('/weight-configs/'),
    get: (id: number) => api.get<WeightConfig>(`/weight-configs/${id}/`),
    create: (data: Partial<WeightConfig>) => api.post<WeightConfig>('/weight-configs/', data),
    update: (id: number, data: Partial<WeightConfig>) => api.patch<WeightConfig>(`/weight-configs/${id}/`, data),
    delete: (id: number) => api.delete(`/weight-configs/${id}/`),
    getPresets: () => api.get<Record<string, WeightPreset>>('/weight-configs/presets/'),
    activate: (id: number) => api.post(`/weight-configs/${id}/activate/`),
    createFromPreset: (skuId: number, presetKey: string) =>
        api.post<WeightConfig>('/weight-configs/create_from_preset/', { sku_id: skuId, preset_key: presetKey }),
};
